// // src/components/CustomerForm.jsx
// import React, { useState, useEffect } from "react";
// import { useNavigate, useParams } from "react-router-dom";
// import "./forms.css";

// const API_BASE = "http://127.0.0.1:5055";

// export default function CustomerForm() {
//   const { id } = useParams();
//   const navigate = useNavigate();

//   const [form, setForm] = useState({
//     name: "",
//     customer_type: "",
//     customer_group: "",
//     territory: "",
//     email: "",
//     phone: "",
//     alt_phone: "",
//     contact_person: "",
//     address_line1: "",
//     address_line2: "",
//     city: "",
//     state: "",
//     postal_code: "",
//     country: "",
//     billing_currency: "",
//     default_price_list: "",
//     account_manager: "",
//     status: "Active",
//     notes: ""
//   });

//   const [loading, setLoading] = useState(false);
//   const [saving, setSaving] = useState(false);
//   const isEdit = Boolean(id);

//   // list state
//   const [customers, setCustomers] = useState([]);
//   const [loadingList, setLoadingList] = useState(false);

//   // view modal
//   const [selectedCustomer, setSelectedCustomer] = useState(null);

//   // load single customer for edit
//   useEffect(() => {
//     if (!isEdit) return;
//     setLoading(true);
//     fetch(`${API_BASE}/api/customers/${id}/`)
//       .then(res => {
//         if (!res.ok) throw new Error("Failed to load customer");
//         return res.json();
//       })
//       .then(data => {
//         setForm({
//           name: data.name || "",
//           customer_type: data.customer_type || "",
//           customer_group: data.customer_group || "",
//           territory: data.territory || "",
//           email: data.email || "",
//           phone: data.phone || "",
//           alt_phone: data.alt_phone || "",
//           contact_person: data.contact_person || "",
//           address_line1: data.address_line1 || "",
//           address_line2: data.address_line2 || "",
//           city: data.city || "",
//           state: data.state || "",
//           postal_code: data.postal_code || "",
//           country: data.country || "",
//           billing_currency: data.billing_currency || "",
//           default_price_list: data.default_price_list || "",
//           account_manager: data.account_manager || "",
//           status: data.status || "Active",
//           notes: data.notes || ""
//         });
//       })
//       .catch(err => {
//         console.error(err);
//         alert("Failed to load customer: " + (err.message || err));
//       })
//       .finally(() => setLoading(false));
//   }, [id, isEdit]);

//   // load customer list
//   useEffect(() => {
//     loadCustomers();
//   }, []);

//   function loadCustomers() {
//     setLoadingList(true);
//     fetch(`${API_BASE}/api/customers/`)
//       .then(res => (res.ok ? res.json() : Promise.reject(new Error("Failed to load customers"))))
//       .then(list => setCustomers(Array.isArray(list) ? list : []))
//       .catch(err => {
//         console.error("Load customers error", err);
//         setCustomers([]);
//       })
//       .finally(() => setLoadingList(false));
//   }

//   async function handleSave(e) {
//     e.preventDefault();
//     if (!form.name || !form.name.trim()) return alert("Customer name is required");
//     setSaving(true);
//     try {
//       const url = isEdit ? `${API_BASE}/api/customers/${id}/` : `${API_BASE}/api/customers/`;
//       const method = isEdit ? "PUT" : "POST";

//       const res = await fetch(url, {
//         method,
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify(form),
//       });

//       if (!res.ok) {
//         const text = await res.text().catch(() => "");
//         // try parse JSON error
//         try {
//           const json = JSON.parse(text || "{}");
//           throw new Error(json.error || json.message || text || res.statusText);
//         } catch {
//           throw new Error(text || res.statusText);
//         }
//       }

//       alert("Customer saved successfully!");
//       // refresh list and navigate to sales (per your previous flow)
//       loadCustomers();
//       navigate("/sales");
//     } catch (err) {
//       console.error(err);
//       alert("Save failed: " + (err.message || err));
//     } finally {
//       setSaving(false);
//     }
//   }

//   async function handleDelete(customerId) {
//     if (!window.confirm("Delete this customer? This action cannot be undone.")) return;
//     try {
//       const res = await fetch(`${API_BASE}/api/customers/${customerId}/`, { method: "DELETE" });
//       if (!res.ok) {
//         const txt = await res.text().catch(() => "");
//         try { const j = JSON.parse(txt || "{}"); throw new Error(j.error || j.message || txt || res.statusText); } catch { throw new Error(txt || res.statusText); }
//       }
//       loadCustomers();
//       alert("Customer deleted");
//     } catch (err) {
//       console.error(err);
//       alert("Delete failed: " + (err.message || err));
//     }
//   }

//   function handleView(c) {
//     setSelectedCustomer(c);
//   }

//   function handleEdit(c) {
//     navigate(`/customer-form/${c.id}`);
//   }

//   return (
//     <div className="form-card">
//       <h2>{isEdit ? "Edit Customer" : "New Customer"}</h2>
//       <p className="lead">Capture full customer details. Fields are optional unless marked required.</p>

//       {loading ? (
//         <div className="muted">Loading…</div>
//       ) : (
//         <form onSubmit={handleSave} className="form-grid" style={{ marginBottom: 20 }}>
//           {/* --- Primary Info --- */}
//           <div className="form-grid form-grid-2">
//             <div className="field">
//               <label>Full name <span className="required">*</span></label>
//               <input
//                 className="input"
//                 value={form.name}
//                 onChange={e => setForm({ ...form, name: e.target.value })}
//                 required
//                 placeholder="Customer full name or company"
//               />
//             </div>

//             <div className="field">
//               <label>Customer type</label>
//               <input
//                 className="input"
//                 value={form.customer_type}
//                 onChange={e => setForm({ ...form, customer_type: e.target.value })}
//                 placeholder="e.g. Individual, Company"
//               />
//             </div>

//             <div className="field">
//               <label>Customer group</label>
//               <input
//                 className="input"
//                 value={form.customer_group}
//                 onChange={e => setForm({ ...form, customer_group: e.target.value })}
//                 placeholder="e.g. Retail, Wholesale"
//               />
//             </div>

//             <div className="field">
//               <label>Territory</label>
//               <input
//                 className="input"
//                 value={form.territory}
//                 onChange={e => setForm({ ...form, territory: e.target.value })}
//                 placeholder="e.g. Nairobi"
//               />
//             </div>

//             <div className="field">
//               <label>Email</label>
//               <input
//                 className="input"
//                 type="email"
//                 value={form.email}
//                 onChange={e => setForm({ ...form, email: e.target.value })}
//                 placeholder="contact@example.com"
//               />
//             </div>

//             <div className="field">
//               <label>Phone</label>
//               <input
//                 className="input"
//                 value={form.phone}
//                 onChange={e => setForm({ ...form, phone: e.target.value })}
//                 placeholder="+254 700 000000"
//               />
//             </div>

//             <div className="field">
//               <label>Alt phone</label>
//               <input
//                 className="input"
//                 value={form.alt_phone}
//                 onChange={e => setForm({ ...form, alt_phone: e.target.value })}
//                 placeholder="Alternate phone"
//               />
//             </div>

//             <div className="field">
//               <label>Contact person</label>
//               <input
//                 className="input"
//                 value={form.contact_person}
//                 onChange={e => setForm({ ...form, contact_person: e.target.value })}
//                 placeholder="Primary contact name"
//               />
//             </div>
//           </div>

//           {/* --- Address --- */}
//           <div className="form-grid form-grid-2">
//             <div className="field">
//               <label>Address line 1</label>
//               <input
//                 className="input"
//                 value={form.address_line1}
//                 onChange={e => setForm({ ...form, address_line1: e.target.value })}
//                 placeholder="Street, building, etc."
//               />
//             </div>

//             <div className="field">
//               <label>Address line 2</label>
//               <input
//                 className="input"
//                 value={form.address_line2}
//                 onChange={e => setForm({ ...form, address_line2: e.target.value })}
//                 placeholder="Apartment, suite, etc."
//               />
//             </div>

//             <div className="field">
//               <label>City</label>
//               <input
//                 className="input"
//                 value={form.city}
//                 onChange={e => setForm({ ...form, city: e.target.value })}
//               />
//             </div>

//             <div className="field">
//               <label>State / County</label>
//               <input
//                 className="input"
//                 value={form.state}
//                 onChange={e => setForm({ ...form, state: e.target.value })}
//               />
//             </div>

//             <div className="field">
//               <label>Postal code</label>
//               <input
//                 className="input"
//                 value={form.postal_code}
//                 onChange={e => setForm({ ...form, postal_code: e.target.value })}
//               />
//             </div>

//             <div className="field">
//               <label>Country</label>
//               <input
//                 className="input"
//                 value={form.country}
//                 onChange={e => setForm({ ...form, country: e.target.value })}
//               />
//             </div>
//           </div>

//           {/* --- Billing / Misc --- */}
//           <div className="form-grid form-grid-2">
//             <div className="field">
//               <label>Billing currency</label>
//               <input
//                 className="input"
//                 value={form.billing_currency}
//                 onChange={e => setForm({ ...form, billing_currency: e.target.value })}
//                 placeholder="e.g. KES, USD"
//               />
//             </div>

//             <div className="field">
//               <label>Default price list</label>
//               <input
//                 className="input"
//                 value={form.default_price_list}
//                 onChange={e => setForm({ ...form, default_price_list: e.target.value })}
//                 placeholder="Price list name"
//               />
//             </div>

//             <div className="field">
//               <label>Account manager</label>
//               <input
//                 className="input"
//                 value={form.account_manager}
//                 onChange={e => setForm({ ...form, account_manager: e.target.value })}
//                 placeholder="Staff name"
//               />
//             </div>

//             <div className="field">
//               <label>Status</label>
//               <select
//                 className="input"
//                 value={form.status}
//                 onChange={e => setForm({ ...form, status: e.target.value })}
//               >
//                 <option>Active</option>
//                 <option>Inactive</option>
//               </select>
//             </div>
//           </div>

//           {/* --- Notes --- */}
//           <div className="field">
//             <label>Notes</label>
//             <textarea
//               className="textarea"
//               value={form.notes}
//               onChange={e => setForm({ ...form, notes: e.target.value })}
//               rows={4}
//               placeholder="Optional notes about the customer"
//             />
//           </div>

//           {/* --- Actions --- */}
//           <div className="form-actions">
//             <button type="button" onClick={() => navigate(-1)} className="btn-ghost btn small-btn">
//               Cancel
//             </button>
//             <button type="submit" disabled={saving} className="btn">
//               {saving ? "Saving..." : isEdit ? "Update Customer" : "Create Customer"}
//             </button>
//           </div>
//         </form>
//       )}

//       {/* --- Customers list (view/edit/delete) --- */}
//       <div style={{ marginTop: 8 }}>
//         <h3 style={{ marginBottom: 8 }}>Customers</h3>

//         {loadingList ? (
//           <div className="muted">Loading customers…</div>
//         ) : customers.length === 0 ? (
//           <div className="muted">No customers found.</div>
//         ) : (
//           <div style={{ overflowX: "auto" }}>
//             <table className="compact-table" style={{ width: "100%", marginTop: 8 }}>
//               <thead>
//                 <tr>
//                   <th>Name</th>
//                   <th>Type</th>
//                   <th>Group</th>
//                   <th>Phone</th>
//                   <th>Email</th>
//                   <th>City</th>
//                   <th style={{ width: 220 }}>Actions</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {customers.map(c => (
//                   <tr key={c.id}>
//                     <td>{c.name}</td>
//                     <td>{c.customer_type || "-"}</td>
//                     <td>{c.customer_group || "-"}</td>
//                     <td>{c.phone || "-"}</td>
//                     <td>{c.email || "-"}</td>
//                     <td>{c.city || "-"}</td>
//                     <td>
//                       <div style={{ display: "flex", gap: 8 }}>
//                         <button type="button" className="btn-ghost small-btn" onClick={() => handleView(c)}>View</button>
//                         <button type="button" className="btn small-btn" onClick={() => handleEdit(c)}>Edit</button>
//                         <button type="button" className="btn btn-danger small-btn" onClick={() => handleDelete(c.id)}>Delete</button>
//                       </div>
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>
//         )}
//       </div>

//       {/* view modal */}
//       {selectedCustomer && (
//         <div
//           style={{
//             position: "fixed",
//             inset: 0,
//             background: "rgba(0,0,0,0.45)",
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "center",
//             zIndex: 1200
//           }}
//           onClick={() => setSelectedCustomer(null)}
//         >
//           <div
//             className="form-card"
//             style={{ width: 700, maxWidth: "calc(100% - 32px)" }}
//             onClick={e => e.stopPropagation()}
//           >
//             <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
//               <h3 style={{ margin: 0 }}>{selectedCustomer.name}</h3>
//               <button className="btn-ghost small-btn" onClick={() => setSelectedCustomer(null)}>Close</button>
//             </div>

//             <div style={{ marginTop: 12 }}>
//               <div style={{ display: "grid", gap: 10, gridTemplateColumns: "1fr 1fr" }}>
//                 <div><strong>Contact</strong><div className="muted">{selectedCustomer.contact_person || "-"}</div></div>
//                 <div><strong>Phone</strong><div className="muted">{selectedCustomer.phone || "-"}</div></div>
//                 <div><strong>Email</strong><div className="muted">{selectedCustomer.email || "-"}</div></div>
//                 <div><strong>Territory</strong><div className="muted">{selectedCustomer.territory || "-"}</div></div>
//                 <div><strong>Address</strong><div className="muted">{`${selectedCustomer.address_line1 || ""} ${selectedCustomer.address_line2 || ""}`.trim() || "-"}</div></div>
//                 <div><strong>City</strong><div className="muted">{selectedCustomer.city || "-"}</div></div>
//               </div>

//               <div style={{ marginTop: 12 }}>
//                 <strong>Notes</strong>
//                 <div className="muted" style={{ whiteSpace: "pre-wrap", marginTop: 6 }}>{selectedCustomer.notes || "-"}</div>
//               </div>

//               <div style={{ marginTop: 16, display: "flex", gap: 8 }}>
//                 <button className="btn" onClick={() => { setSelectedCustomer(null); navigate(`/customer-form/${selectedCustomer.id}`); }}>Edit</button>
//                 <button className="btn btn-danger" onClick={() => { setSelectedCustomer(null); handleDelete(selectedCustomer.id); }}>Delete</button>
//                 <button className="btn-ghost" onClick={() => setSelectedCustomer(null)}>Close</button>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }


/// src/components/CustomerForm.jsx
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import DashboardLayout from "./DashboardLayout";
import "./forms.css";

const API_BASE = "https://dairy.server.statify.co.ke/";

function CustomerFormContent({ noLayout } = {}) {
  const navigate = useNavigate();

  const [loadingList, setLoadingList] = useState(false);
  const [customers, setCustomers] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState(null); // view modal
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [creating, setCreating] = useState(false);

  // edit modal state
  const [showEditModal, setShowEditModal] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [editing, setEditing] = useState(false);

  const [deletingId, setDeletingId] = useState(null);

  // quick create form state
  const [createForm, setCreateForm] = useState({ name: "", phone: "", email: "" });

  // edit form (prefilled when opening edit modal)
  const [editForm, setEditForm] = useState({ name: "", phone: "", email: "" });

  useEffect(() => {
    loadCustomers();
  }, []);

  function loadCustomers() {
    setLoadingList(true);
    fetch(`${API_BASE}/api/customers/`)
      .then(res => {
        if (!res.ok) throw new Error(`Failed to load customers (${res.status})`);
        return res.json();
      })
      .then(list => setCustomers(Array.isArray(list) ? list : []))
      .catch(err => {
        console.error("Load customers error", err);
        setCustomers([]);
      })
      .finally(() => setLoadingList(false));
  }

  // Create
  async function handleCreate(e) {
    e?.preventDefault();
    if (!createForm.name || !createForm.name.trim()) return alert("Name is required");
    setCreating(true);
    try {
      const payload = { name: createForm.name.trim(), phone: createForm.phone?.trim() || null, email: createForm.email?.trim() || null };
      const res = await fetch(`${API_BASE}/api/customers/`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });
      if (!res.ok) {
        const txt = await res.text().catch(() => "");
        try { const j = JSON.parse(txt || "{}"); throw new Error(j.error || j.message || txt || res.statusText); } catch { throw new Error(txt || res.statusText); }
      }
      alert("Customer created");
      setShowCreateModal(false);
      setCreateForm({ name: "", phone: "", email: "" });
      loadCustomers();
    } catch (err) {
      console.error("Create failed", err);
      alert("Create failed: " + (err.message || err));
    } finally {
      setCreating(false);
    }
  }

  // Delete
  async function handleDelete(customerId) {
    if (!customerId) return;
    if (!window.confirm("Delete this customer? This cannot be undone.")) return;
    setDeletingId(customerId);
    try {
      const res = await fetch(`${API_BASE}/api/customers/${customerId}/`, { method: "DELETE" });
      if (!res.ok) {
        const txt = await res.text().catch(() => "");
        try { const j = JSON.parse(txt || "{}"); throw new Error(j.error || j.message || txt || res.statusText); } catch { throw new Error(txt || res.statusText); }
      }
      alert("Customer deleted");
      loadCustomers();
    } catch (err) {
      console.error("Delete failed", err);
      alert("Delete failed: " + (err.message || err));
    } finally {
      setDeletingId(null);
    }
  }

  // View
  function handleView(c) {
    setSelectedCustomer(c);
  }

  // EDIT: open edit modal and prefill the form
  function handleEditOpen(c) {
    setEditingId(c.id);
    setEditForm({
      name: c.name || "",
      phone: c.phone || "",
      email: c.email || ""
    });
    setShowEditModal(true);
  }

  // Submit edit (PUT)
  async function handleEditSubmit(e) {
    e?.preventDefault();
    if (!editingId) return alert("No customer selected for edit");
    if (!editForm.name || !editForm.name.trim()) return alert("Name is required");
    setEditing(true);
    try {
      const payload = {
        name: editForm.name.trim(),
        phone: editForm.phone?.trim() || null,
        email: editForm.email?.trim() || null
      };
      const res = await fetch(`${API_BASE}/api/customers/${editingId}/`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });
      if (!res.ok) {
        const txt = await res.text().catch(() => "");
        try { const j = JSON.parse(txt || "{}"); throw new Error(j.error || j.message || txt || res.statusText); } catch { throw new Error(txt || res.statusText); }
      }
      alert("Customer updated");
      setShowEditModal(false);
      setEditingId(null);
      setEditForm({ name: "", phone: "", email: "" });
      loadCustomers();
    } catch (err) {
      console.error("Edit failed", err);
      alert("Edit failed: " + (err.message || err));
    } finally {
      setEditing(false);
    }
  }

  return (
    <div className="form-card">
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <div>
          <h2 style={{ margin: 0 }}>Customers</h2>
        </div>

        <div>
          <button className="btn" onClick={() => setShowCreateModal(true)}>+ Create Customer</button>
        </div>
      </div>

      <div style={{ marginTop: 18 }}>
        {loadingList ? (
          <div className="muted">Loading customers…</div>
        ) : customers.length === 0 ? (
          <div className="muted">No customers found.</div>
        ) : (
          <div style={{ overflowX: "auto" }}>
            <table className="compact-table" style={{ width: "100%", marginTop: 8 }}>
              <thead>
                <tr>
                  <th style={{ width: 80 }}>ID</th>
                  <th>Name</th>
                  <th>Phone</th>
                  <th>Email</th>
                  <th style={{ width: 220 }}>Actions</th>
                </tr>
              </thead>
              <tbody>
                {customers.map(c => (
                  <tr key={c.id}>
                    <td>{c.id}</td>
                    <td>{c.name}</td>
                    <td>{c.phone || "-"}</td>
                    <td>{c.email || "-"}</td>
                    <td>
                      <div style={{ display: "flex", gap: 8 }}>
                        <button type="button" className="btn-ghost small-btn" onClick={() => handleView(c)}>View</button>
                        <button type="button" className="btn small-btn" onClick={() => handleEditOpen(c)}>Edit</button>
                        <button type="button" className="btn btn-danger small-btn" onClick={() => handleDelete(c.id)} disabled={deletingId === c.id}>
                          {deletingId === c.id ? "Deleting..." : "Delete"}
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>

      {/* Create modal */}
      {showCreateModal && (
        <div
          onClick={() => { if (!creating) setShowCreateModal(false); }}
          style={{
            position: "fixed", inset: 0, zIndex: 1400,
            background: "rgba(0,0,0,0.45)", display: "flex", alignItems: "center", justifyContent: "center"
          }}
        >
          <div className="form-card" style={{ width: 520, maxWidth: "calc(100% - 32px)" }} onClick={e => e.stopPropagation()}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <h3 style={{ margin: 0 }}>Create Customer</h3>
              <button className="btn-ghost small-btn" onClick={() => { if (!creating) setShowCreateModal(false); }}>×</button>
            </div>

            <form onSubmit={handleCreate} style={{ marginTop: 12 }}>
              <div className="field">
                <label>Name <span className="required">*</span></label>
                <input className="input" value={createForm.name} onChange={e => setCreateForm(v => ({ ...v, name: e.target.value }))} required />
              </div>

              <div className="field">
                <label>Phone</label>
                <input className="input" value={createForm.phone} onChange={e => setCreateForm(v => ({ ...v, phone: e.target.value }))} />
              </div>

              <div className="field">
                <label>Email</label>
                <input className="input" type="email" value={createForm.email} onChange={e => setCreateForm(v => ({ ...v, email: e.target.value }))} />
              </div>

              <div style={{ display: "flex", gap: 8, marginTop: 12 }}>
                <button type="button" className="btn-ghost small-btn" onClick={() => setShowCreateModal(false)} disabled={creating}>Cancel</button>
                <button type="submit" className="btn" disabled={creating}>{creating ? "Creating..." : "Create"}</button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Edit modal */}
      {showEditModal && (
        <div
          onClick={() => { if (!editing) { setShowEditModal(false); setEditingId(null); } }}
          style={{
            position: "fixed", inset: 0, zIndex: 1400,
            background: "rgba(0,0,0,0.45)", display: "flex", alignItems: "center", justifyContent: "center"
          }}
        >
          <div className="form-card" style={{ width: 520, maxWidth: "calc(100% - 32px)" }} onClick={e => e.stopPropagation()}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <h3 style={{ margin: 0 }}>Edit Customer</h3>
              <button className="btn-ghost small-btn" onClick={() => { if (!editing) { setShowEditModal(false); setEditingId(null); } }}>×</button>
            </div>

            <form onSubmit={handleEditSubmit} style={{ marginTop: 12 }}>
              <div className="field">
                <label>Name <span className="required">*</span></label>
                <input className="input" value={editForm.name} onChange={e => setEditForm(v => ({ ...v, name: e.target.value }))} required />
              </div>

              <div className="field">
                <label>Phone</label>
                <input className="input" value={editForm.phone} onChange={e => setEditForm(v => ({ ...v, phone: e.target.value }))} />
              </div>

              <div className="field">
                <label>Email</label>
                <input className="input" type="email" value={editForm.email} onChange={e => setEditForm(v => ({ ...v, email: e.target.value }))} />
              </div>

              <div style={{ display: "flex", gap: 8, marginTop: 12 }}>
                <button type="button" className="btn-ghost small-btn" onClick={() => { setShowEditModal(false); setEditingId(null); }} disabled={editing}>Cancel</button>
                <button type="submit" className="btn" disabled={editing}>{editing ? "Saving..." : "Save changes"}</button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* View modal - simplified to show only ID, Name, Phone, Email */}
      {selectedCustomer && (
        <div
          style={{
            position: "fixed", inset: 0, background: "rgba(0,0,0,0.45)",
            display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1200
          }}
          onClick={() => setSelectedCustomer(null)}
        >
          <div className="form-card" style={{ width: 520, maxWidth: "calc(100% - 32px)" }} onClick={e => e.stopPropagation()}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <h3 style={{ margin: 0 }}>{selectedCustomer.name}</h3>
              <button className="btn-ghost small-btn" onClick={() => setSelectedCustomer(null)}>Close</button>
            </div>

            <div style={{ marginTop: 12 }}>
              <div style={{ display: "grid", gap: 10, gridTemplateColumns: "1fr 1fr" }}>
                <div>
                  <strong>ID</strong>
                  <div className="muted">{selectedCustomer.id}</div>
                </div>

                <div>
                  <strong>Name</strong>
                  <div className="muted">{selectedCustomer.name}</div>
                </div>

                <div>
                  <strong>Phone</strong>
                  <div className="muted">{selectedCustomer.phone || "-"}</div>
                </div>

                <div>
                  <strong>Email</strong>
                  <div className="muted">{selectedCustomer.email || "-"}</div>
                </div>
              </div>

              <div style={{ marginTop: 16, display: "flex", gap: 8 }}>
                <button className="btn" onClick={() => { setSelectedCustomer(null); handleEditOpen(selectedCustomer); }}>Edit</button>
                <button className="btn btn-danger" onClick={() => { setSelectedCustomer(null); handleDelete(selectedCustomer.id); }}>Delete</button>
                {/* <button className="btn-ghost" onClick={() => setSelectedCustomer(null)}>Close</button> */}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

/**
 * Default export: wrap with DashboardLayout unless caller passes { noLayout: true } prop.
 * This keeps your requirement "add layout to CustomerForm.jsx" and doesn't alter the content code.
 */
export default function CustomerForm(props) {
  const { noLayout } = props || {};
  const content = <CustomerFormContent {...props} />;

  if (noLayout) return content;

  // Wrap with DashboardLayout so when navigating to /customer-form it renders inside the app shell.
  return <DashboardLayout>{content}</DashboardLayout>;
}
